/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { Chip as MUIChip } from '@mui/material';

import ChipProps from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
const ChipView: React.FC<ChipProps> = (props) => {
  const {
    sx,
    borderColor,
    borderRadius,
    color,
    variant = 'filled',
    disableTouchRipple = true,
    onDelete,
    ...restProps
  } = props;

  // =============== VIEWS
  return (
    <MUIChip
      {...restProps}
      variant={variant}
      color={color}
      onDelete={onDelete}
      sx={{
        height: 'auto',
        fontWeight: 500,
        lineHeight: '22px',
        ...(disableTouchRipple && {
          '.MuiTouchRipple-root': {
            display: 'none',
          },
        }),
        ...(!!onDelete && { paddingRight: '2px' }),
        ...(borderColor && { borderColor: `${borderColor} !important` }),
        ...(borderRadius && { borderRadius }),
        ...sx,
      }}
    />
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './props';
export const Chip = memo(ChipView);
